export default __webpack_public_path__ + "static/media/cert_charter.4dc6e450.jpg";